import { UserInteractionType } from '../Model/BankConfig';

export const entrepreneurResponse = {
  name: 'Fake Entrepreneur',
  mobile: '06505555555',
  _id: '617bf000ac53a2e6cbc3e9cf',
  email: 'test.entrepreneur@automatik.hu',
  created: '2021-10-29T12:58:40.557Z',
  companies: [
    {
      name: 'Káposzta Bt.',
      taxNumber: '12345678',
      _id: '617bf547ff1082e787d11154',
      created: '2021-10-29T13:21:11.118Z',
      szamlazzApiToken: '',
      integration: '',
      aggreg8Isc: '',
      status: 'preRegistered',
      aggreg8Accounts: [
        {
          accountId: '617bf547',
          accountNumber: '12345678',
          bankAccessConsentExpirationDate: '2021-10-29T13:21:11.118Z',
        },
      ],
      accountants: [
        {
          _id: '617bf808b3fd10e7ea96fcea',
          name: 'Könyvelő Bt.',
          email: 'konyvelo@konyvelo.hu',
          mobile: '20/123-1234',
          created: '2021-10-29T13:32:56.604Z',
        },
      ],
      bankConfigs: [
        {
          accountNr: '12345678',
          fieldName: 'fakeField1',
          fieldValue: 'fakeValue1',
        },
      ],
      __v: 0,
    },
  ],
  __v: 0,
};

export const entrepreneurResponseWithoutPreregistered = {
  name: 'Fake Entrepreneur',
  mobile: '06505555555',
  _id: '617bf000ac53a2e6cbc3e9cf',
  email: 'test.entrepreneur@automatik.hu',
  created: '2021-10-29T12:58:40.557Z',
  companies: [
    {
      name: 'Káposzta Bt.',
      taxNumber: '12345678',
      _id: '617bf547ff1082e787d11154',
      created: '2021-10-29T13:21:11.118Z',
      szamlazzApiToken: '',
      integration: '',
      aggreg8Isc: '',
      aggreg8Accounts: [
        {
          accountId: '617bf547',
          accountNumber: '12345678',
        },
      ],
      accountants: [
        {
          _id: '617bf808b3fd10e7ea96fcea',
          name: 'Könyvelő Bt.',
          email: 'konyvelo@konyvelo.hu',
          mobile: '20/123-1234',
          created: '2021-10-29T13:32:56.604Z',
        },
      ],
      __v: 0,
    },
  ],
  __v: 0,
};

export const companyList = [
  {
    name: 'Káposzta Bt. 1',
    taxNumber: '12345678',
    _id: '617bf547ff1082e787d11152',
    created: '2021-10-29T13:21:11.118Z',
    szamlazzApiToken: '',
    integration: '',
    aggreg8Isc: '',
    aggreg8Accounts: [
      {
        _id: '6369282c1d5f1f00c2aa0ab4',
        accountNumber: '104040275052665248761007',
        bankAccessConsentExpirationDate: '2021-10-29T13:21:11.118Z',
      },
      {
        _id: '636e2d12c0725c097727f2ee',
        accountNumber: '107000247204937651100005',
        bankAccessConsentExpirationDate: new Date(new Date().setDate(new Date().getDate() + 6)).toISOString(),
      },
    ],
    accountants: [
      {
        _id: '617bf808b3fd10e7ea96fcea',
        name: 'Könyvelő Bt.',
        email: 'konyvelo@konyvelo.hu',
        mobile: '20/123-1234',
        created: '2021-10-29T13:32:56.604Z',
      },
    ],
    __v: 0,
  },
  {
    name: 'Káposzta Bt. 2',
    taxNumber: '12345678',
    _id: '617bf547ff1082e787d11154',
    created: '2021-10-29T13:21:11.118Z',
    szamlazzApiToken: '',
    integration: '',
    aggreg8Isc: '',
    aggreg8Accounts: [
      {
        _id: '636e2e0ec0725c097727fc1d',
        accountNumber: '107002447327022351100005',
        bankAccessConsentExpirationDate: '2021-10-29T13:21:11.118Z',
      },
      {
        _id: '636e2d12c0725c097727f2ee',
        accountNumber: '107000247204937651100005',
        bankAccessConsentExpirationDate: new Date().setDate(new Date().getDate() - 6),
      },
    ],
    accountants: [
      {
        _id: '617bf808b3fd10e7ea96fcea',
        name: 'Könyvelő Bt.',
        email: 'konyvelo@konyvelo.hu',
        mobile: '20/123-1234',
        created: '2021-10-29T13:32:56.604Z',
      },
    ],
    __v: 0,
  },
];

export const accessTokenLists = [
  {
    _id: '6310acece4878b7b8079b3f6',
    clientId: 'f7723b17c6b282e70b0e9cbafc89f40815941f3097e52091aa50287a11214c6d',
    integrator: {
      displayName: 'Adriana',
      logoUri: '',
      _id: '63108c238f78c4316e1f1651',
    },
    status: 'REVOKED',
    createdAt: '2022-09-01T13:00:28.053Z',
    revokedAt: '2022-09-01T13:00:52.585Z',
  },
  {
    _id: '6311e285bc8f3b38cff182a2',
    clientId: '06ec15d3aa794d9a06baba8bb1171d9d7cd05a2b1e47857b068ebf1bf3b4fe56',
    integrator: {
      displayName: 'Adriana',
      logoUri: '',
      _id: '63108c238f78c4316e1f1651',
    },
    status: 'ACTIVE',
    createdAt: '2022-09-02T11:01:24.964Z',
    lastUsed: '2022-09-02T11:02:01.173Z',
  },
];

export const integratorsResponse = [
  {
    displayName: 'Adriana',
    logoUri: '',
    _id: '63108c238f78c4316e1f1651',
  },
  {
    displayName: 'Fake Integrator',
    logoUri: '',
    _id: '63108c238f78c4316e1f1631',
  },
];

export const expectedBankAccountList = {
  accounts: [
    {
      accountId: '636e2e0ec0725c097727fc1d',
      bankName: null,
      displayName: 'Fake Bank',
      accountNr: '107002447327022351100005',
      companyId: '62d9a7e9bf4ed34fd0d64e38',
      originate: 'aggreg8',
    },
    {
      accountId: '636e2d12c0725c097727f2ee',
      bankName: 'The most evil bank',
      displayName: null,
      accountNr: '107000247204937651100005',
      companyId: '62d9a7e9bf4ed34fd0d64e38',
      originate: 'aggreg8',
    },
    {
      accountId: '6369282c1d5f1f00c2aa0ab4',
      bankName: 'OTP Bank',
      displayName: null,
      accountNr: '104040275052665248761007',
      companyId: '62d9a7e9bf4ed34fd0d64e38',
      originate: 'aggreg8',
    },
  ],
  statistics: [
    {
      date: '2022-11-10T00:00:00.000Z',
      accountNr: '107002447327022351100005',
      originate: 'aggreg8',
      credit: 278975,
      debit: 0,
    },
    {
      date: '2022-11-11T00:00:00.000Z',
      accountNr: '104040275052665248761007',
      originate: 'aggreg8',
      credit: 204198,
      debit: -5000,
    },
  ],
};

export const transactionResponse = [
  {
    _id: '617bf808b3fd10e7ea96fcea',
    partnerName: 'test name',
    partnerAccountNr: 'HU92107007707013619351100005',
    amount: 5600,
    currency: 'HUF',
    type: 'test_type',
    description: 'test description',
    bookingDate: '2021-09-28T00:00:00.000+00:00',
    booked: true,
    transactionObjectId: '617bf808b3fd10e7ea96fasd',
  },
];

export const createAccessTokenResponse = { client_id: 'clientId', client_secret: 'clientSecret' };

export const fileUploadResponse = {
  name: 'random_name.extension',
  originalName: 'original_file_name.txt',
  status: 'processing',
  transactionCount: 0,
  created: '2022.10.09',
};

export const accountantResponse = {
  _id: '617bf808b3fd10e7ea96fcea',
  name: 'Könyvelő Bt.',
  email: 'konyvelo@konyvelo.hu',
  mobile: '20/123-1234',
  created: '2021-10-29T13:32:56.604Z',
};

export const finishedFileResponse = {
  name: 'OTP export BÖBÉNEK (1).xls',
  status: 'finished',
  created: '2021-10-29T13:10:44.812Z',
  _id: '617bf2d412b95ee73a01189e',
  transactionCount: 123,
  duplicates: [1, 2, 3],
  skipped: [1, 2, 3, 56, 77],
  bankAccounts: ['12345678-00000001'],
  interval: {
    start: '2021-10-29T13:10:44.812Z',
    end: '2021-12-29T13:10:44.812Z',
  },
};

export const pendingFileResponse = {
  name: 'OTP export BÖBÉNEK (1).xls',
  status: 'pending',
  created: '2021-10-29T13:10:44.812Z',
  _id: '617bf2d412b95ee73a01189e',
  transactionCount: 123,
  duplicates: [1, 2, 3],
  skipped: [1, 2, 3, 56, 77],
  bankAccounts: ['12345678-00000001'],
  interval: {
    start: '2021-10-29T13:10:44.812Z',
    end: '2021-12-29T13:10:44.812Z',
  },
};

export const responseFromAggreg8 = {
  status: 'SYNC_STARTED',
  customerSyncToken: 'string',
  shouldDoPolling: false,
};

export const iscResponse = [
  {
    _id: 'string',
    bankId: 'string',
    consentedAccounts: [
      {
        _id: 'string',
        name: 'string',
        bankId: 'string',
        balance: 0,
        availableBalance: 0,
        bookedBalance: 0,
        currency: 'string',
        accountNumber: 'string',
        owner: {
          name: 'string',
          id: 'string',
          source: 'BANK_ACCOUNT_OWNER_FIELD',
        },
        lastSuccessfulSyncDate: '2022-10-25T08:43:30.073Z',
        transactionCounter: 0,
        createdAt: '2022-10-25T08:43:30.073Z',
        updatedAt: '2022-10-25T08:43:30.073Z',
      },
    ],
    bankAccessConsentExpirationDate: '2021-01-01T19:47:47Z',
    customer: {
      _id: 'string',
      name: 'string',
      companyName: 'string',
      dataHandlingPurposes: ['string'],
    },
  },
];

export const responseFromAggreg8AccountsListMultipleElement = [
  {
    _id: 'fake_id_1',
    name: 'fake_name_1',
    bankId: 'fake_bank_id_1',
    balance: 1000,
    availableBalance: 1000,
    bookedBalance: 1000,
    currency: 'HUF',
    accountNumber: 'fake_account_number_1',
    owner: {
      name: 'fake_owner_name_1',
      id: 'fake_owner_id_1',
      source: 'fake_owner_source_1',
    },
    lastSuccessfulSyncDate: '2022-10-25T08:43:30.073Z',
    transactionCounter: 10,
    createdAt: '2022-10-25T08:43:30.073Z',
    updatedAt: '2022-10-25T08:43:30.073Z',
  },
  {
    _id: 'fake_id_2',
    name: 'fake_name_2',
    bankId: 'fake_bank_id_2',
    balance: 2000,
    availableBalance: 2000,
    bookedBalance: 2000,
    currency: 'HUF',
    accountNumber: 'fake_account_number_2',
    owner: {
      name: 'fake_owner_name_2',
      id: 'fake_owner_id_2',
      source: 'fake_owner_source_2',
    },
    lastSuccessfulSyncDate: '2022-10-25T08:43:30.073Z',
    transactionCounter: 10,
    createdAt: '2022-10-25T08:43:30.073Z',
    updatedAt: '2022-10-25T08:43:30.073Z',
  },
  {
    _id: 'fake_id_3',
    name: 'fake_name_3',
    bankId: 'fake_bank_id_3',
    balance: 2000,
    availableBalance: 2000,
    bookedBalance: 2000,
    currency: 'HUF',
    accountNumber: 'fake_account_number_3',
    owner: {
      name: 'fake_owner_name_3',
      id: 'fake_owner_id_2',
      source: 'fake_owner_source_2',
    },
    lastSuccessfulSyncDate: '2022-10-25T08:43:30.073Z',
    transactionCounter: 10,
    createdAt: '2022-10-25T08:43:30.073Z',
    updatedAt: '2022-10-25T08:43:30.073Z',
  },
  {
    _id: 'fake_id_4',
    name: 'fake_name_4',
    bankId: 'fake_bank_id_4',
    balance: 2000,
    availableBalance: 2000,
    bookedBalance: 2000,
    currency: 'HUF',
    accountNumber: 'fake_account_number_4',
    owner: {
      name: 'fake_owner_name_4',
      id: 'fake_owner_id_2',
      source: 'fake_owner_source_2',
    },
    lastSuccessfulSyncDate: '2022-10-25T08:43:30.073Z',
    transactionCounter: 10,
    createdAt: '2022-10-25T08:43:30.073Z',
    updatedAt: '2022-10-25T08:43:30.073Z',
  },
  {
    _id: 'fake_id_5',
    name: 'fake_name_5',
    bankId: 'fake_bank_id_5',
    balance: 2000,
    availableBalance: 2000,
    bookedBalance: 2000,
    currency: 'HUF',
    accountNumber: 'fake_account_number_5',
    owner: {
      name: 'fake_owner_name_5',
      id: 'fake_owner_id_2',
      source: 'fake_owner_source_2',
    },
    lastSuccessfulSyncDate: '2022-10-25T08:43:30.073Z',
    transactionCounter: 10,
    createdAt: '2022-10-25T08:43:30.073Z',
    updatedAt: '2022-10-25T08:43:30.073Z',
  },
];

export const responseFromAggreg8BanksList = [
  {
    _id: 'fake_bank_id_1',
    name: 'fake_bank_name_1',
    availableCountries: ['hu'],
    availableInSync: true,
    logo: 'fake_bank_logo_1',
    connectionQualityIndicator: {
      value: 'OK',
      updatedAt: '2023-01-04T14:54:36.967Z',
    },
  },
  {
    _id: 'fake_bank_id_2',
    name: 'fake_bank_name_2',
    availableCountries: ['hu'],
    availableInSync: true,
    logo: 'fake_bank_logo_1',
    connectionQualityIndicator: {
      value: 'OK',
      updatedAt: '2023-01-04T14:54:36.967Z',
    },
  },
  {
    _id: 'fake_bank_id_3',
    name: 'fake_bank_name_3',
    availableCountries: ['hu'],
    availableInSync: true,
    logo: 'fake_bank_logo_1',
    connectionQualityIndicator: {
      value: 'OK',
      updatedAt: '2023-01-04T14:54:36.967Z',
    },
  },
  {
    _id: 'fake_bank_id_4',
    name: 'fake_bank_name_4',
    availableCountries: ['hu'],
    availableInSync: true,
    logo: 'fake_bank_logo_1',
    connectionQualityIndicator: {
      value: 'OK',
      updatedAt: '2023-01-04T14:54:36.967Z',
    },
  },
  {
    _id: 'fake_bank_id_5',
    name: 'fake_bank_name_5',
    availableCountries: ['hu'],
    availableInSync: true,
    logo: 'fake_bank_logo_1',
    connectionQualityIndicator: {
      value: 'OK',
      updatedAt: '2023-01-04T14:54:36.967Z',
    },
  },
];

export const bankConfigs = [
  {
    _id: 'fake_bank_id_1',
    bankName: 'OTP Bank',
    accountCode: 123,
    fieldName: 'fake_field_name_1',
    fieldValue: 'fake_field_value_1',
    userInterActionType: UserInteractionType.INPUT,
    displayName: 'fake_display_name_1',
  },
];
